export function isWeComBrowser() {
  const userAgent = navigator.userAgent.toLowerCase();
  if (
    userAgent.match(/micromessenger/i)?.[0] === 'micromessenger' &&
    userAgent.match(/wxwork/i)?.[0] === 'wxwork'
  ) {
    return true;
  }
  return false;
}
